/**
 * @generated SignedSource<<70257df94fa4c1c1e667dc1ea2480cbe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamsAppForYouWatermelonQuery$variables = {
  kudosAfter?: string | null;
  kudosFirst?: number | null;
  kudosQuery: string;
  skipQuery?: boolean | null;
  workspaceId: string;
};
export type TeamsAppForYouWatermelonQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"KudosRowQuery">;
};
export type TeamsAppForYouWatermelonQuery = {
  response: TeamsAppForYouWatermelonQuery$data;
  variables: TeamsAppForYouWatermelonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kudosAfter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kudosFirst"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kudosQuery"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skipQuery"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v5 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "kudosAfter"
},
v6 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "kudosFirst"
},
v7 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "picture"
},
v10 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TeamsAppForYouWatermelonQuery",
    "selections": [
      {
        "condition": "skipQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "kudosQuery"
              },
              (v7/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "KudosRowQuery"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamsAppForYouWatermelonQuery",
    "selections": [
      {
        "condition": "skipQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "kudosQuery"
              },
              (v7/*: any*/)
            ],
            "concreteType": "KudosConnection",
            "kind": "LinkedField",
            "name": "kudosTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "KudosEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Kudos",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "uuid"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "imageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "stillImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "bgTheme"
                      },
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "giver",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/)
                            ]
                          },
                          (v11/*: any*/)
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                          }
                        ],
                        "concreteType": "KudosRecipientConnection",
                        "kind": "LinkedField",
                        "name": "recipients",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "KudosRecipientEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "KudosRecipient",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "recipient",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "UserPII",
                                        "kind": "LinkedField",
                                        "name": "pii",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v8/*: any*/),
                                          (v9/*: any*/)
                                        ]
                                      },
                                      (v11/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "Team",
                                    "kind": "LinkedField",
                                    "name": "team",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "teamId"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "avatarUrl"
                                      },
                                      (v11/*: any*/)
                                    ]
                                  },
                                  (v11/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "recipients(first:1)"
                      },
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "d0120e0d6565a9641a41f4859537522e",
    "id": null,
    "metadata": {},
    "name": "TeamsAppForYouWatermelonQuery",
    "operationKind": "query",
    "text": "query TeamsAppForYouWatermelonQuery(\n  $workspaceId: ID!\n  $kudosQuery: String!\n  $kudosFirst: Int\n  $kudosAfter: String\n  $skipQuery: Boolean = false\n) {\n  ...KudosRowQuery_3anzp1 @skip(if: $skipQuery)\n}\n\nfragment KudosContent on Kudos {\n  uuid\n  ari\n  description\n  imageUrl\n  stillImageUrl\n  type\n  bgTheme\n  giver {\n    pii {\n      name\n      picture\n      accountId\n    }\n    id\n  }\n  recipients(first: 1) {\n    edges {\n      node {\n        recipient {\n          pii {\n            accountId\n            name\n            picture\n          }\n          id\n        }\n        team {\n          name\n          teamId\n          avatarUrl\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment KudosRowQuery_3anzp1 on Query {\n  kudosTql(workspaceId: $workspaceId, q: $kudosQuery, first: $kudosFirst, after: $kudosAfter) {\n    edges {\n      node {\n        ...KudosContent\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1b94dd115118749a0b38f51be8c5f7c";

export default node;
